<template>
  <v-sheet height="100%" flat class="d-flex flex-column">
    <KeepAlive include="MainView">
      <router-view></router-view>
    </KeepAlive>
  </v-sheet>
</template>

<script>
  export default {
    name: 'facility-page',
  };
</script>
